import config from 'config/Config';
import request from 'utils/request';

export default class {
  // 获取蜂鸟积分
  static getTotalScore(params) {
    return request({
      url: `member/coin/balance`,
      host: config.HOST_MALL,
      params,
      ignoreErr: true
    });
  }

  static getCouponNum() {
    return request({
      url: `member/coin/convertible/quantity`,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Wallet/Score/ScoreServ.js